<nz-card class="flow-card" nzTitle="Catalog">
    <p class="flow-card__subtitle">Select a SKU and reserve it to continue.</p>

    <form nz-form [formGroup]="catalogForm" [nzLayout]="'vertical'" nzNoColon class="flow-form">
        <nz-form-item class="flow-form__item">
            <nz-form-label [nzRequired]="true" nzFor="selectedSku">SKU</nz-form-label>
            <nz-form-control>
                <nz-select id="selectedSku" formControlName="selectedSku" placeholder="Choose a SKU" nzAllowClear>
                    <nz-option *ngFor="let s of availableSkus" [nzValue]="s.sku" [nzLabel]="s.label"></nz-option>
                </nz-select>
            </nz-form-control>
        </nz-form-item>

        <div class="flow-actions flow-actions--trailing">
            <button nz-button nzType="primary" [disabled]="catalogForm.invalid" [nzLoading]="reserveLoading"
                (click)="reserve()">
                Reserve SKU
            </button>
        </div>
    </form>
</nz-card>